import { useEffect, useRef } from 'react'
import { Animated, Easing } from 'react-native'

export const Pulse = ({ delay = 0, repeat }: { delay: number; repeat: boolean }) => {
  const animation = useRef(new Animated.Value(0)).current

  useEffect(() => {
    const timing = Animated.timing(animation, {
      toValue: 1,
      duration: 2000,
      easing: Easing.linear,
      useNativeDriver: true,
      delay,
    })

    const anim = repeat ? Animated.loop(timing) : timing
    anim.start()

    return () => anim.stop()
  }, [])

  const opacity = animation.interpolate({
    inputRange: [0, 1],
    outputRange: [0.6, 0],
  })

  return (
    <Animated.View
      style={[
        {
          width: 200,
          borderRadius: 150,
          height: 200,
          position: 'absolute',
          borderColor: '#FE500084',
          borderWidth: 4,
          backgroundColor: '#FE5000',
        },
        {
          opacity,
          transform: [{ scale: animation }],
        },
      ]}
    />
  )
}
